import React from 'react';
import LandingPage from '../LandingPage';
import UsersPage from '../../pages/users';
import Dashbaord from '../../pages/dashboard';
import ChefsAndRestaurants from '../../pages/ChefsAndRestaurants';
import FoodItemsPage from '../../pages/foogItems';
import OrdersPage from '../../pages/orders';
import CategoriesPage from '../../pages/manageCategories';
import PromoCodesPage from '../../pages/promocodes';
import NewsLetterPage from '../../pages/newsletter';
import TagsPage from '../../pages/tags';
import ReportsPage from '../../pages/reports';
import UserDetailsPage from '../../pages/userDetails';
import SettlementsHistoryPage from '../../pages/settlementsHistory';
import EnjoyfreshMarginsPage from '../../pages/EnjoyfreshMargins';
import ChefAndRestaurantDetails from '../../pages/chefAndRestaurantDetails';
import FoodItemDetailsPage from '../../pages/foodItemDetails';
import OrderDetailsPage from '../../pages/orderDetails';
import FaqsPage from '../../pages/faqs';
import WalletPage from '../../pages/wallet';
import PaymentsPage from '../../pages/Payments';
import SettlementsPage from '../../pages/Settlements';
import AddFoodItemsPage from '../../pages/AddFoodItems';
import UpdateFoodItemPage from '../../pages/UpdateFoodItem';
import Banners from '../../pages/Banners';
import AppVersions from '../../pages/AppVersions';
import Discounts from '../Discounts';
import Analytics from '../../pages/Analytics';
import VerifyPaymentsPage from '../../pages/verifyPayments';

const Routes = [
    {
        path: "/users",
        component: <><h1>{<UsersPage />}</h1></>
    },
    {
        path: "/wallet",
        component: <>{<WalletPage />}</>
    },
    {
        path: "/payments",
        component: <>{<PaymentsPage />}</>
    },
    {
        path: "/verify-payment",
        component: <>{<VerifyPaymentsPage />}</>
    },
    {
        path: "/settlements",
        component: <>{<SettlementsPage />}</>
    },
    {
        path: "/dashboard",
        component: <>{<Dashbaord />}</>
    },
    {
        path: "/restaurants",
        component: <>{<ChefsAndRestaurants />}</>
    },
    {
        path: "/fooditems",
        component: <>{<FoodItemsPage />}</>
    },
    {
        path: "/orders",
        component: <>{<OrdersPage />}</>
    },
    {
        path: "/categories",
        component: <>{<CategoriesPage />}</>
    },
    {
        path: "/resolution",
        component: <>{""}</>
    },
    {
        path: "/promocodes",
        component: <>{<PromoCodesPage />}</>
    },
    {
        path: "/newsletters",
        component: <>{<NewsLetterPage />}</>
    },
    {
        path: "/reports",
        component: <>{<ReportsPage />}</>
    },
    {
        path: "/webcontent",
        component: <>{""}</>
    },
    {
        path: "/tags",
        component: <>{<TagsPage />}</>
    },
    {
        path: "/faqs",
        component: <>{<FaqsPage />}</>
    },
    {
        path: "/settings",
        component: <>{""}</>
    },
    {
        path: "/users/:id",
        component: <>{<UserDetailsPage />}</>
    },
    {
        path: "/settlements/:id/:name",
        component: <>{<SettlementsHistoryPage />}</>
    },
    {
        path: "/enjoyfreshmargins",
        component: <>{<EnjoyfreshMarginsPage />}</>
    },
    {
        path: "/restaurant/:id",
        component: <>{<ChefAndRestaurantDetails />}</>
    },
    {
        path: "/fooditems/:id",
        component: <>{<FoodItemDetailsPage />}</>
    },
    {
        path: "/orders/:id",
        component: <>{<OrderDetailsPage />}</>
    },
    {
        path: "/additems",
        component: <>{<AddFoodItemsPage />}</>
    },
    {
        path: "/updateitem/:sid/:did/:cid",
        component: <>{<UpdateFoodItemPage />}</>
    },
    {
        path: "/",
        component: <>{<LandingPage />}</>,
    },
    {
        path: "/chef/:id",
        component: <>{<ChefAndRestaurantDetails />}</>,
    },
    {
        path: "/banners",
        component: <>{<Banners />}</>
    },
    {
        path: "/app-versions",
        component: <>{<AppVersions />}</>
    },
    {
        path: "/discounts",
        component: <>{<Discounts />}</>
    },
    {
        path: "/analytics",
        component: <>{<Analytics />}</>
    },
];

export default Routes;
